import {
  ConceptNode,
  ConceptNodeMap,
  RawConceptData,
} from "../../Concepts.interface";

export const buildConceptTree = (
  items: Record<string, RawConceptData>,
): { rootNode: ConceptNode | null; map: ConceptNodeMap } => {
  const map: ConceptNodeMap = {};

  const buildNode = (id: string): ConceptNode => {
    const item = items[id] as RawConceptData;
    const node = {
      id,
      name: item.data.name,
      description: item.data.description || "",
      parentId: item.data.parent,
      isFolder: item.isFolder,
      children: item.children.map((childId: string) => buildNode(childId)),
    };

    map[node.id] = node;
    return node;
  };

  // Find the root "Document" i.e. ELA, Science, Social studies.
  const rootId = Object.keys(items).find(
    (id) => (items[id] as RawConceptData).data.object_type === "Document",
  );

  const rootNode = rootId ? buildNode(rootId) : null;

  return { rootNode, map };
};
